import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Iframe from 'react-iframe'

// const Overlay = styled.div`
//   width: 100%;
//   z-index: 1;
//   height: ${props => props.height};
//   background-color: rgb(43, 44, 54);
// `

const StlyedIframe = styled(Iframe)`
  position: relative !important;
  width: ${props => props.width};
  height: ${props => props.height};
`

const Map = ({ url, width, height }) => {
  return (
    <StlyedIframe url={url} width={width} height={height} frameborder='0' style='border:0' allowfullscreen />
  )
}

Map.propTypes = {
  /**
   * URL for the map
   */
  url: PropTypes.string.isRequired,

  /**
   * Width of the map
   */
  width: PropTypes.string,

  /**
   * Height of the map
   */
  height: PropTypes.string
}

Map.defaultProps = {
  width: '100%',
  height: '550px'
}

export default Map



// WEBPACK FOOTER //
// ./src/components/UI/GoogleMap/index.js